import { render, staticRenderFns } from "./KpiViewTabs.vue?vue&type=template&id=7b178bc8&scoped=true"
import script from "./KpiViewTabs.vue?vue&type=script&lang=js"
export * from "./KpiViewTabs.vue?vue&type=script&lang=js"
import style0 from "./KpiViewTabs.vue?vue&type=style&index=0&id=7b178bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b178bc8",
  null
  
)

export default component.exports